import React from "react"

export const ElektonischeBekanntmachungIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32.9}
      height={27.1}
      style={{
        overflow: "visible",
        enableBackground: "new 0 0 32.9 27.1",
      }}
      xmlSpace="preserve"
      {...props}
    >
      <style>{".st0{fill:none;stroke:#035470;stroke-width:1.8}"}</style>
      <path className="st0" d="M32 8H8v15.7l15.9.2L32 26V8z" />
      <path
        d="M1 1h24v15.7l-16 .1L1 19V1z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#ffd62e",
          stroke: "#ffd62e",
          strokeWidth: 1.9362,
        }}
      />
      <path className="st0" d="M4 5h13M4 9h10" />
    </svg>
  )
}
